import React, { createContext, useState, useContext, ReactNode} from 'react';
import {Clip, Highlight} from '../types/clipTypes'

interface SelectedClipsProps {
    selectedClip: Clip | undefined | Highlight;
    setSelectedClip: (selectedClip: Clip | undefined | Highlight) => void;
}

const SelectedClipContext = createContext<SelectedClipsProps | undefined>(undefined);

const SelectedClipProvider: React.FC<{ children: ReactNode }> = ({ children }) => {

    const [selectedClip, setSelectedClip] = useState<Clip | undefined | Highlight>();

    return (
        <SelectedClipContext.Provider value={{selectedClip, setSelectedClip}}>
            {children}
        </SelectedClipContext.Provider>
    );
};

// Custom hook to use the filter context
const useSelectedClip = () => {
    const context = useContext(SelectedClipContext);
    if (context === undefined) {
        throw new Error('useSelectedClip must be used within a SelectedClip provider');
    }
    return context;
};

export { SelectedClipProvider, useSelectedClip };